<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else class="wrapper">
      <div class="title-container">
        <div v-if="activeStep === 1" class="title-screen">
          <span>{{ adminText('organizationAll.message_to_subscribers_89ba48f4', 'Message to subscribers') }}</span>
        </div>
        <main-button v-if="activeStep == 1" :text="adminText('organizationAll.add_new_message_cc2885b5', 'Add new message')" @click="activeStep = 2" />
      </div>
      <organizer-messages
        v-if="activeStep == 1"
        :messages="myAllMessages"
        @edit="editMessage($event)"
        @sendMessage="handleSendOrganizerMessage($event)"
      />
      <new-organizer-message
        v-if="activeStep == 2"
        @cancel="activeStep = 1"
        @create="handleCreateOrganizerMessage($event)"
      />
      <edit-organizer-message
        v-if="activeStep == 3"
        :initial-value="editMessageData"
        @cancel="
          activeStep = 1
          editMessageData = {}
        "
        @delete="deleteMessage($event)"
        @update="handleUpdateMessage($event)"
      />
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import Spinner from '../../shared/spinner.vue'
import {
  GET_ORGANIZATION_MESSAGES,
  CREATE_ORGANIZATION_MESSAGE,
  DELETE_ORGANIZATION_MESSAGE,
  UPDATE_ORGANIZATION_MESSAGE,
  SEND_ORGANIZATION_MESSAGE,
} from '../../../graphql/organizationMessage.graphql'
import OrganizerMessages from '../../events/OrganizerMessages.vue'
import NewOrganizerMessage from '../../events/NewOrganizerMessage.vue'
import EditOrganizerMessage from '../../events/edit-organizer-message.vue'

export default {
  mixins: [OrganizationLocalization],
  name: 'messages',
  components: {
    Spinner,
    NewOrganizerMessage,
    OrganizerMessages,
    EditOrganizerMessage,
  },
  props: {
    eventId: String,
    organizationSlug: String,
  },
  data() {
    return {
      activeStep: 1,
      myAllMessages: [],
      editMessageData: {},
    }
  },
  methods: {
    async handleUpdateMessage(data) {
      await this.$apollo.mutate({
        mutation: UPDATE_ORGANIZATION_MESSAGE,
        variables: {
          data,
          organizationSlug: this.organizationSlug,
        },
        refetchQueries: [
          {
            query: GET_ORGANIZATION_MESSAGES,
            variables: { organizationSlug: this.organizationSlug },
          },
        ],
        awaitRefetchQueries: true,
      })
      this.activeStep = 1
    },
    async deleteMessage(id) {
      await this.$apollo.mutate({
        mutation: DELETE_ORGANIZATION_MESSAGE,
        variables: {
          organizationMessageId: id,
          organizationSlug: this.organizationSlug,
        },
        refetchQueries: [
          {
            query: GET_ORGANIZATION_MESSAGES,
            variables: { organizationSlug: this.organizationSlug },
          },
        ],
        awaitRefetchQueries: true,
      })
      this.activeStep = 1
    },
    editMessage(id) {
      this.editMessageData = this.myAllMessages.find(a => a.id === id)
      this.activeStep = 3
    },
    async handleCreateOrganizerMessage(data) {
      await this.$apollo.mutate({
        mutation: CREATE_ORGANIZATION_MESSAGE,
        variables: {
          data,
          organizationSlug: this.organizationSlug,
        },
        refetchQueries: [
          {
            query: GET_ORGANIZATION_MESSAGES,
            variables: { organizationSlug: this.organizationSlug },
          },
        ],
        awaitRefetchQueries: true,
      })
      this.activeStep = 1
    },
    async handleSendOrganizerMessage(id) {
      await this.$apollo.mutate({
        mutation: SEND_ORGANIZATION_MESSAGE,
        variables: {
          organizationMessageId: id,
          organizationSlug: this.organizationSlug,
        },
        refetchQueries: [
          {
            query: GET_ORGANIZATION_MESSAGES,
            variables: { organizationSlug: this.organizationSlug },
          },
        ],
        awaitRefetchQueries: true,
      })
    },
  },
  apollo: {
    getOrganizationMessages: {
      query: GET_ORGANIZATION_MESSAGES,
      variables() {
        return { organizationSlug: this.organizationSlug }
      },
      result({ data, loading }) {
        if (!loading && data) {
          this.myAllMessages = data.getOrganizationMessages
        }
      },
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .title-screen {
    display: none;
  }
  .wrapper {
    margin-top: 1.5rem;
  }
}
.wrapper {
  max-width: 42.5rem;
}
.title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
}
</style>
